<template>
  <div
    v-if="icone == 'mdi-paw-outline'"
    class="pa-1 d-flex align-center justify-center"
  >
    <v-img
      v-if="isModeDevelopment()"
      src="../../assets/dev-hoof-print.png"
      contain
      max-width="27"
    ></v-img>
    <v-img
      v-else
      src="../../assets/hoof-print.png"
      contain
      max-width="27"
    ></v-img>
  </div>
  <v-icon color="primary" v-else>{{ icone }}</v-icon>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    icone: { type: String, required: true },
  },
  methods: {
    ...mapGetters("sistema",["isModeDevelopment"])
  }
};
</script>

<style>
</style>